import { Inject, Pipe, PipeTransform } from '@angular/core';

import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';

const PROD_DOMAIN: string = 'https://www.xfinity.com';
const PROD_MOBILE_BASE: string = `${PROD_DOMAIN}/mobile`;
const PRE_PROD_DOMAIN: string = 'https://www.stg.xfinity.com';
const STAGE_BASE: string = 'https://xmobile-d2c.xfinity.com/staging';

@Pipe({
    name: 'xmEnvLink',
    standalone: false
})
export class XmEnvLinkPipe implements PipeTransform {
    private config: IXMOptions;

    constructor(@Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { config });
    }

    public transform(url: string): string {
        if (['prod'].includes(this.config.LOG_ENV)) {
            return url;
        } else if (['pre-prod'].includes(this.config.LOG_ENV)) {
            return url.replace(PROD_DOMAIN, PRE_PROD_DOMAIN);
        }

        return url.replace(PROD_MOBILE_BASE, STAGE_BASE);
    }
}
